export default __webpack_public_path__ + "static/media/3239.0c519dbc.png";